export const ONBOARDING_STEPS = 3;
export const ONBOARDING = 'onboarding';
export const OnboardingStep = {
  CONNECT_DATA: 'connect_data',
  ANALYZE: 'analyze',
  CREATE_SMARTSLIDES: 'create_smartslides',
  INVITE_TEAM: 'invite_team',
  SHARE: 'share',
  DONE: 'done',
};

export const OnboardingEvent = {
  CONNECT_DATA: 'OnboardingEvent:connect_data',
  CREATE_DASHBOARD: 'OnboardingEvent:create_dashboard',
  CREATE_SMARTSLIDES: 'OnboardingEvent:create_smartslides',
  INVITE_TEAM: 'OnboardingEvent:invite_team',
  CREATE_REPORT: 'OnboardingEvent:create_report',
  ADDED_CREDIT_CARD: 'OnboardingEvent:added_credit_card',
  DASHBOARD_GENERATED: 'OnboardingEvent:dashboard_generated',
};

export const OnboardingTrendShape = {
  LINE: 'line',
  BARS: 'bars',
  SPIKES: 'spikes',
  GEO: 'geo',
  FUNNEL: 'funnel',
  COMPOSITE: 'composite',
};

export const OnboardingFlow = {
  AUTOPILOT: 'autopilot',
  CLASSIC: 'classic',
};

export const OnboardingQuestionStep = {
  GOAL: 'goal',
  NORTH_STAR: 'north_star',
  CONNECTORS: 'connectors',
};

export const OnboardingGoal = {
  EXECUTIVE_OVERVIEW: 'Executive Performance',
  TRENDS_OVER_TIME: 'Marketing Trends',
  CHANNEL_CAMPAIGN_BREAKDOWN: 'Campaign Performance',
  TOP_PERFORMERS: 'Top Performing Channels',
  GEOGRAPHIC_PERFORMANCE: 'Geographic Performance',
  CONVERSION_FUNNEL: 'Conversion Funnel',
};

/** Maps pre-rename goal labels so mid-flow saved answers still resolve. */
export const OnboardingGoalLegacyAliases = Object.freeze({
  'Executive overview': OnboardingGoal.EXECUTIVE_OVERVIEW,
  'Trends over time': OnboardingGoal.TRENDS_OVER_TIME,
  'Channel / campaign breakdown': OnboardingGoal.CHANNEL_CAMPAIGN_BREAKDOWN,
  'Top performers': OnboardingGoal.TOP_PERFORMERS,
  'Geographic performance': OnboardingGoal.GEOGRAPHIC_PERFORMANCE,
  'Conversion funnel': OnboardingGoal.CONVERSION_FUNNEL,
});

export const OnboardingKpi = {
  ROAS: 'ROAS',
  CPA: 'CPA',
  CONVERSION_RATE: 'Conversion Rate',
  REVENUE: 'Revenue',
  LEADS: 'Leads',
};

export const OnboardingDashboardBuildStatus = {
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  FAILED: 'failed',
};

export const OnboardingDashboardBuildFailureReason = {
  QUOTA: 'quota',
  UNSUPPORTED_CONNECTOR: 'unsupported_connector',
  BUILD_ERROR: 'build_error',
  TIMEOUT: 'timeout',
};

export const OnboardingConnector = {
  FACEBOOK_ADS: 'Meta Ads',
  GOOGLE_ADS: 'Google Ads',
  GOOGLE_ANALYTICS_4: 'Google Analytics 4',
  FACEBOOK_INSIGHTS: 'Facebook Insights',
  LINKEDIN_ADS: 'LinkedIn Ads',
  GOOGLE_SEARCH_CONSOLE: 'Google Search Console',
  TIKTOK_ADS: 'TikTok Ads',
  MICROSOFT_ADVERTISING: 'Microsoft Advertising',
  GOOGLE_BUSINESS_PROFILE: 'Google Business Profile',
};

/** Service catalog still uses Facebook Ads; onboarding displays Meta Ads. */
export const OnboardingConnectorServiceAliases = Object.freeze({
  [OnboardingConnector.FACEBOOK_ADS]: 'Facebook Ads',
});

/** Maps pre-rename connector labels so mid-flow saved answers still resolve. */
export const OnboardingConnectorLegacyAliases = Object.freeze({
  'Facebook Ads': OnboardingConnector.FACEBOOK_ADS,
});

export const BOOK_DEMO_URL =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ15vowD1g7yNwfcV0R9wN3NRK1VZ7EapMW2Paebv0bMqBBws_eZU2m-10nB9SzXMLnp08JytEji?gv=true';

/** Indices into the autopilot build-step list; COMPLETE is one past the last step. */
export const AutopilotBuildStep = {
  UNDERSTAND: 0,
  PRIORITIZE: 1,
  CONNECT: 2,
  DISCOVER: 3,
  FETCH: 4,
  LAYOUT: 5,
  COMPLETE: 6,
};

export const OnboardingPathName = 'onboarding';
export const OnboardingClassicPathName = 'onboarding-classic';
